export const filterList = {
    company: ["Universal Pictures","CAA","Earl Smith Productions"],
    division: ["Talent","Literary Agency","Corporate"],
    category: ["Actor","Show","Agent"],
    title:["Lead Actor","Lead Actress","Supporting Actor"],
    status:["Active","Inactive"],
    customGroup:["CG1","CG2","CG3"]
}